/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// $(document).on('ready', function () {
//     $(".main_slideshow").slick({
//         dots: true,
//         infinite: false,
//         slidesToShow: 1,
//         slidesToScroll: 1
//     });
// });

// Add profile element to customer to filter out bots
document.addEventListener("DOMContentLoaded", function () {

  document.addEventListener('product:added', function(event) {
    console.warn('added to cart');
  _learnq.push(['identify', {
      ecr_validated: true
    }]);
  });
});

// Custom pack quantity handling
document.addEventListener("DOMContentLoaded", function () {
  // Check if we're on a product page with pack quantity requirements
  const packQuantityElement = document.querySelector("[data-pack-quantity]");
  if (!packQuantityElement) {
    return;
  }

  const packQuantity = parseInt(
    packQuantityElement.getAttribute("data-pack-quantity")
  );
  if (!packQuantity || packQuantity <= 1) {
    return;
  }

  console.log("Pack quantity detected:", packQuantity);

  // Find the quantity picker
  const quantityPicker = document.querySelector(".quantity-selector--product");
  if (!quantityPicker) {
    console.log("Quantity picker not found");
    return;
  }

  const quantityInput = quantityPicker.querySelector('[name="quantity"]');
  const decreaseButton = quantityPicker.querySelector(
    '[data-action="decrease-picker-quantity"]'
  );
  const increaseButton = quantityPicker.querySelector(
    '[data-action="increase-picker-quantity"]'
  );

  if (!quantityInput || !decreaseButton || !increaseButton) {
    console.log("Quantity picker elements not found");
    return;
  }

  // Create message element for validation feedback
  let messageElement = document.createElement("p");
  messageElement.className = "pack-quantity-message";
  messageElement.style.color = "#e74c3c";
  messageElement.style.fontSize = "14px";
  messageElement.style.marginTop = "5px";
  messageElement.style.display = "none";
  quantityPicker.parentNode.appendChild(messageElement);

  function validateQuantity(quantity) {
    console.log("Validating quantity:", quantity);
    if (quantity % packQuantity !== 0) {
      messageElement.textContent = `Quantity must be in multiples of ${packQuantity}`;
      messageElement.style.display = "block";
      return false;
    } else {
      messageElement.style.display = "none";
      return true;
    }
  }

  function updateQuantity(newQuantity) {
    console.log("Updating quantity to:", newQuantity);
    // Ensure quantity is never less than pack quantity
    if (newQuantity < packQuantity) {
      newQuantity = packQuantity;
    }

    // Round down to nearest pack quantity multiple
    newQuantity = Math.floor(newQuantity / packQuantity) * packQuantity;

    quantityInput.value = newQuantity;
    validateQuantity(newQuantity);
  }

  // Custom event handlers
  function handleDecrease(e) {
    console.log("Decrease button clicked");
    e.preventDefault();
    e.stopPropagation();
    const currentQuantity = parseInt(quantityInput.value) || packQuantity;
    const newQuantity = currentQuantity - packQuantity;
    updateQuantity(newQuantity);
  }

  function handleIncrease(e) {
    console.log("Increase button clicked");
    e.preventDefault();
    e.stopPropagation();
    const currentQuantity = parseInt(quantityInput.value) || packQuantity;
    const newQuantity = currentQuantity + packQuantity;
    updateQuantity(newQuantity);
  }

  function handleInput() {
    const quantity = parseInt(quantityInput.value) || 0;
    validateQuantity(quantity);
  }

  function handleBlur() {
    const quantity = parseInt(quantityInput.value) || packQuantity;
    updateQuantity(quantity);
  }

  // Clone the buttons to remove all existing event listeners
  const newDecreaseButton = decreaseButton.cloneNode(true);
  const newIncreaseButton = increaseButton.cloneNode(true);

  decreaseButton.parentNode.replaceChild(newDecreaseButton, decreaseButton);
  increaseButton.parentNode.replaceChild(newIncreaseButton, increaseButton);

  // Add our custom event listeners to the new buttons
  newDecreaseButton.addEventListener("click", handleDecrease);
  newIncreaseButton.addEventListener("click", handleIncrease);
  quantityInput.addEventListener("input", handleInput);
  quantityInput.addEventListener("blur", handleBlur);

  // Initialize with pack quantity
  console.log("Initializing with pack quantity");
  updateQuantity(packQuantity);
});
